/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification>): BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification(), model);
        BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification>): BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification.newInstance(<BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
